module.exports = __webpack_public_path__ + "img/hourglass.724dce68.png";